import React from 'react'
import { PuckConfigContext } from './PuckConfigContext'
import { FontRegistryProvider } from './fonts/FontRegistryContext'

/**
 * Aggregated providers for puck-aware rendering.
 * Child sites pass their puckConfig; nested providers (font registry, etc.)
 * are mounted here so consumers only wrap once.
 */
export const PuckProviders = ({ config, children }) => (
  <PuckConfigContext.Provider value={config}>
    <FontRegistryProvider>{children}</FontRegistryProvider>
  </PuckConfigContext.Provider>
)
